












































import { Vue, Component } from 'vue-property-decorator'
import { Nullable } from '@/types/general'
import Onboarding from '@/util/Onboarding'
import { setPageTitle } from '@/util/Helpers'
import VPage from './VPage.vue'

@Component({ name: 'verify-email', components: { VPage } })
export default class VerifyEmail extends Vue {
    token: Nullable<string> = null

    success: Nullable<boolean> = null
    message: string = ''

    async mounted(): Promise<void> {
        setPageTitle('Verify email address')
        this.token = this.$route.params.token
        try {
            await Onboarding.verifyEmail(this.token)
            this.success = true
        } catch (err) {
            this.success = false
            if (err.response && err.response.data && err.response.data.message) {
                this.message = err.response.data.message
            } else {
                this.message = err
            }
        }
    }
}
